<app-menu *ngIf="showMenu"></app-menu>

<div class="app-content" [class.no-menu]="!showMenu">
  <router-outlet></router-outlet>
</div>
